/** Screen wake lock while navigating, reacquired on visibility return. */

let sentinel: WakeLockSentinel | null = null;
let wanted = false;

async function acquire(): Promise<void> {
  if (!('wakeLock' in navigator) || sentinel) return;
  try {
    sentinel = await navigator.wakeLock.request('screen');
    sentinel.addEventListener('release', () => {
      sentinel = null;
    });
  } catch {
    // Denied (battery saver etc.) - non-fatal.
  }
}

export function enableWakeLock(): void {
  wanted = true;
  void acquire();
}

export function disableWakeLock(): void {
  wanted = false;
  void sentinel?.release();
  sentinel = null;
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible' && wanted) void acquire();
});
